import {BUDGET_TYPE} from "../../../constants";

export default class ProjectUtil {
	static handleSprintLengthChange(value) {
		// Clamp sprint length between 0 and 365
		const clampedValue = Math.max(0, Math.min(365, parseInt(value, 10)));
		return isNaN(clampedValue) ? value : clampedValue;
	}
	static getDefaultRateCard(formatMessage, defaultRateCard, companyCurrency) {
		if (defaultRateCard) {
			return {value: defaultRateCard.id, label: defaultRateCard.name, currency: defaultRateCard ? defaultRateCard.currency : companyCurrency};
		} else {
			return {value: null, label: formatMessage({id: 'rate_card_selector.no_rate_card_text'}), currency: companyCurrency};
		}
	}

	static getFixedPriceData(project, availableFeatureFlags) {
		return {newFixedPrice: false, isFixedPriceProject: project.budgetType === BUDGET_TYPE.FIXED_PRICE_V2};
		/* Logic removed until final decision on fixed price, also not compatible with lazy loaded sprints/scoping
		const taskCount = project.tasks.edges.filter(task => task.node.billable && task.node.approved).length;
		const billableScope = project.tasks.edges.reduce((acc, task) => (task.node.billable && task.node.approved ? task.node.estimateForecast + acc : acc), 0);
		const newFixedPrice = hasFeatureFlag('new_fixed_price', availableFeatureFlags) && project.budgetType === BUDGET_TYPE.FIXED_PRICE && project.budgetWork;

		return {taskCount, billableScope, newFixedPrice};
		*/
	}

	/**
	 * returns correct actual revenue based on billable
	 * @param {object} task task
	 * @param {object} fixedPriceData object containing taskCount, billableScope, and newFixedPrice
	 * - taskCount: amount of tasks in project
	 * - billableScope: combined scope of all billable + approved tasks in minutes
	 * - newFixedPrice: project fixed revenue if has featureflag and fixed revenue project, undefined otherwise
	 * @returns {number} actual revenue for task
	 */
	static getActualPriceForTask(task, fixedPriceData) {
		// Old fixed price
		if (fixedPriceData?.newFixedPrice) {
			return (task.progress / 100) * this.getEstimatedPrice(task, fixedPriceData);
		}
		// Fixed price v2
		if (fixedPriceData?.isFixedPriceProject) {
			return task.calculatedActualRevenue;
		}
		return task.billable && task.approved && task.timeRegistrations?.edges?.length > 0 ? task.timeRegistrations.edges.reduce((acc, timeReg) => acc + timeReg.node.price, 0) : 0;
	}

	/**
	 * returns correct plan revenue based on billable
	 * @param {object} task task
	 * @param {object} fixedPriceData object containing taskCount, billableScope, and newFixedPrice
	 * - taskCount: amount of tasks in project
	 * - billableScope: combined scope of all billable + approved tasks in minutes
	 * - newFixedPrice: project fixed revenue if has featureflag and fixed revenue project, undefined otherwise
	 * @returns {number} plan revenue for task
	 */
	static getEstimatedPrice(task, fixedPriceData) {
		// Old fixed price
		if (fixedPriceData?.newFixedPrice) {
			const {taskCount, billableScope, newFixedPrice} = fixedPriceData;
			if (!task.billable || !task.approved) {
				return 0;
			}
			if (billableScope === 0 && taskCount) {
				return newFixedPrice / taskCount;
			}
			const scopePercentage = task.estimateForecast / billableScope;
			return scopePercentage * newFixedPrice;
		}
		// Fixed price v2
		if (fixedPriceData?.isFixedPriceProject) {
			return task.calculatedPlannedRevenue;
		}
		return task.billable && task.approved && task.estimateForecastPrice !== null ? task.estimateForecastPrice : 0;
	}
}
